import React, { Fragment, useState, useEffect, useRef } from "react";
import { Redirect } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Button from "@mui/material/Button";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import { Link, Navigate, useNavigate } from "react-router-dom";
import Lottie from "lottie-react";
import loading from "../components/loading.json";
import { themeStyle, themeStyleDark } from "../components/Components";
import { gsap } from "gsap";
import Backdrop from "@mui/material/Backdrop";
import bg from "../bg.mp4";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { Grid } from "@mui/material";
import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import EmailIcon from "@mui/icons-material/Email";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import VisitUs from "../components/VisitUs";
import CountUp from "react-countup";
import Benchmark from "./Benchmark";
import Slider from "./Slider";

export default function About() {
  const state = useSelector((state) => state);

  useEffect(() => {}, []);

  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <div className="overlay"></div>
        <div
          className="abouthero"
          style={{
            background:
              "linear-gradient(0deg, rgba(2, 77, 194, 0.2), rgba(2, 77, 194, 0.2)), url('" +
              require("../img/AGIS (6).jpeg") +
              "')",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div
            style={{
              fontSize: state.auth.isMobile ? "30px" : "30px",
              fontWeight: "bold",
              fontFamily: "Montserrat",
              color:
                state.auth.theme == "dark"
                  ? themeStyleDark.primaryButtonTextColor
                  : themeStyle.primaryButtonTextColor,
            }}
          >
            Facilities
          </div>
        </div>
        {/* <div
          className="aboutabout"
          style={{
            fontSize: state.auth.isMobile ? "18px" : "22px",
            marginBottom: "80px",
            textAlign: "justify",
          }}
        >
          <div
            style={{
              fontSize: "45px",
              fontWeight: "bold",
              fontFamily: "Montserrat",
              color: themeStyle.primaryColor,
              marginBottom: "50px",
            }}
          >
            Hostel
          </div>
          <b>
            {" "}
            At ASPIRE Grove International Pre-School, Devanahalli Premium
            International Pre-School , we are proud to provide our male students
            with comfortable, secure, and well-maintained hostel facilities. Our
            hostel is designed to foster a community environment, promoting both
            academic and personal growth. The rooms are designed for comfort,
            with provisions for both single and shared accommodation. The hostel
            is equipped with all necessary amenities, including study areas,
            recreational facilities, and Wi-Fi connectivity, to ensure a
            conducive living and learning environment.
          </b>
          <br />
          <br />
          In addition to the physical facilities, we place great emphasis on the
          overall wellbeing of our hostel residents. The hostel administration
          is always available to assist students and address their concerns
          promptly. Regular safety and security measures are in place to ensure
          the wellbeing of the residents. We also promote various activities
          aimed at community building and recreational engagement to provide a
          holistic hostel life. ASPIRE Grove International Pre-School,
          Devanahalli Premium International Pre-School ’s hostel is not just a
          place to stay, but a space that contributes significantly to our
          students’ overall college experience.
        </div>
        <div className="aboutabout">
          <div
            style={{
              fontSize: "28px",
              fontFamily: "Montserrat",
              textAlign: "left",
              color:
                state.auth.theme == "dark"
                  ? themeStyleDark.primaryColor
                  : themeStyle.primaryColor,
              fontWeight: "bold",
              marginBottom: "25px",
            }}
          >
            Comfortable and Secure Living Spaces
          </div>
          <div
            style={{
              fontSize: state.auth.isMobile ? "18px" : "25px",
              fontFamily: "Montserrat",
              textAlign: "justify",
            }}
          >
            The hostel at ASPIRE Grove International Pre-School, Devanahalli
            Premium International Pre-School offers a safe, comfortable, and
            nurturing environment where students can focus on their academic and
            personal growth. The rooms are spacious and well-ventilated, with
            modern furnishings that ensure a cozy and home-like atmosphere. Each
            room is equipped with individual study desks, ample storage space,
            and comfortable beds to cater to the needs of young scholars. The
            hostel provides 24/7 security with CCTV surveillance, secure entry
            points, and regular patrols to ensure the safety of all residents.
            Additionally, a dedicated hostel warden is always available to
            address the students' concerns, ensuring a peaceful and supportive
            living environment.
          </div>
        </div>
        <div className="aboutabout">
          <Grid container spacing={5}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div
                style={{
                  fontSize: "28px",
                  fontFamily: "Montserrat",
                  textAlign: "left",
                  color:
                    state.auth.theme == "dark"
                      ? themeStyleDark.primaryColor
                      : themeStyle.primaryColor,
                  fontWeight: "bold",
                }}
              >
                Holistic Development and Recreation
              </div>
              <br />
              <div
                style={{
                  fontSize: state.auth.isMobile ? "18px" : "22px",
                  fontFamily: "Montserrat",
                  textAlign: "justify",
                }}
              >
                ASPIRE Grove International Pre-School, Devanahalli Premium
                International Pre-School 's hostel emphasizes the holistic
                development of its residents, offering a balanced mix of
                academics, extracurricular activities, and recreation. The
                hostel has designated study areas for uninterrupted learning and
                access to resources such as libraries and computer labs. To
                promote physical fitness and well-being, the hostel features
                sports facilities, including a gym, basketball court, and a
                playground, where students can engage in various activities.
                Regularly organized events, such as movie nights, talent shows,
                and cultural programs, provide opportunities for students to
                relax and bond with their peers, fostering a sense of community
                and belonging among residents.
              </div>
            </Grid>
          </Grid>
        </div>

        <div className="aboutabout">
          <Grid container spacing={5}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div
                style={{
                  fontSize: "28px",
                  fontFamily: "Montserrat",
                  textAlign: "left",
                  color:
                    state.auth.theme == "dark"
                      ? themeStyleDark.primaryColor
                      : themeStyle.primaryColor,
                  fontWeight: "bold",
                }}
              >
                Healthy and Nutritious Dining
              </div>
              <br />
              <div
                style={{
                  fontSize: state.auth.isMobile ? "18px" : "22px",
                  fontFamily: "Montserrat",
                  textAlign: "justify",
                }}
              >
                Ensuring the well-being of our students is a top priority at the
                ASPIRE Grove International Pre-School, Devanahalli Premium
                International Pre-School boys' hostel, and this extends to
                providing nutritious meals that support their growth and energy
                needs. The hostel's dining hall offers a variety of balanced
                meals, prepared under strict hygiene standards by experienced
                chefs. The menu is thoughtfully designed to include a wide range
                of dishes that cater to different tastes and dietary
                requirements, ensuring that students enjoy a healthy and varied
                diet. Regular feedback from students is encouraged to
                continuously improve the dining experience. The dining area is
                also a social hub where students come together to share meals,
                fostering friendships and a sense of camaraderie.
              </div>
            </Grid>
          </Grid>
        </div> */}
        <div
          className="aboutabout"
          style={{
            fontSize: state.auth.isMobile ? "18px" : "22px",
            marginBottom: "80px",
            marginTop: "100px",
            textAlign: "justify",
          }}
        >
          <div
            style={{
              fontSize: "45px",
              fontWeight: "bold",
              fontFamily: "Montserrat",
              color: themeStyle.primaryColor,
              marginBottom: "50px",
            }}
          >
            Playground
          </div>
          <b>
            {" "}
            ASPIRE Grove International Pre-School, Devanahalli Premium
            International Pre-School boasts a safe and stimulating playground
            designed specifically for early years. This vibrant space allows
            children to explore their physical capabilities through
            age-appropriate structures like slides, swings, climbs, and sensory
            play areas. It is a place where gross motor skills are developed in
            a fun and secure environment.
          </b>
          <br />
          <br />
          Our playground is more than just a play area; it is where social bonds
          are formed. Children learn to share, take turns, and play
          cooperatively. The safe, cushioned flooring ensures that every
          adventure is worry-free. We believe that outdoor play is essential for
          a child's holistic growth, connecting them with nature and each other.
        </div>
        <div className="aboutabout">
          <div
            style={{
              fontSize: "28px",
              fontFamily: "Montserrat",
              textAlign: "justify",
              color:
                state.auth.theme == "dark"
                  ? themeStyleDark.primaryColor
                  : themeStyle.primaryColor,
              fontWeight: "bold",
              marginBottom: "25px",
            }}
          >
            A Dynamic Space for Play and Learning
          </div>
          <div
            style={{
              fontSize: state.auth.isMobile ? "18px" : "25px",
              fontFamily: "Montserrat",
              textAlign: "justify",
            }}
          >
            The playground features modern, age-appropriate equipment including
            low-height climbers, tunnels, and sand pits. These elements are
            chosen to spark imagination and encourage active play. The design
            focuses on safety and accessibility, ensuring every child can
            participate and enjoy their time outdoors.
          </div>
        </div>
        <div className="aboutabout">
          <Grid container spacing={5}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div
                style={{
                  fontSize: "28px",
                  fontFamily: "Montserrat",
                  textAlign: "justify",
                  color:
                    state.auth.theme == "dark"
                      ? themeStyleDark.primaryColor
                      : themeStyle.primaryColor,
                  fontWeight: "bold",
                }}
              >
                Encouraging Physical Fitness and Fun
              </div>
              <br />
              <div
                style={{
                  fontSize: state.auth.isMobile ? "18px" : "22px",
                  fontFamily: "Montserrat",
                  textAlign: "justify",
                }}
              >
                Physical activity is vital for young children. Our playground
                encourages running, jumping, and balancing, which are crucial
                for physical development. Structured outdoor time helps children
                build strength and coordination while having fun in the fresh
                air.
              </div>
            </Grid>
          </Grid>
        </div>
        <div className="aboutabout">
          <Grid container spacing={5}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div
                style={{
                  fontSize: "28px",
                  fontFamily: "Montserrat",
                  textAlign: "left",
                  color:
                    state.auth.theme == "dark"
                      ? themeStyleDark.primaryColor
                      : themeStyle.primaryColor,
                  fontWeight: "bold",
                }}
              >
                A Space for Social and Emotional Growth
              </div>
              <br />
              <div
                style={{
                  fontSize: state.auth.isMobile ? "18px" : "22px",
                  fontFamily: "Montserrat",
                  textAlign: "justify",
                }}
              >
                The playground is a key setting for social and emotional
                learning. Guided by our caring staff, children learn to navigate
                social interactions, build resilience, and develop empathy. It
                is a happy place where confidence grows with every slide and
                swing.
              </div>
            </Grid>
          </Grid>
        </div>
        <div
          className="aboutabout"
          style={{
            fontSize: state.auth.isMobile ? "18px" : "22px",
            marginBottom: "80px",
          }}
        >
          <div
            style={{
              fontSize: "45px",
              fontWeight: "bold",
              fontFamily: "Montserrat",
              color: themeStyle.primaryColor,
              marginTop: "50px",
            }}
          >
            Indoor Activity Room
          </div>
        </div>
        <div className="aboutabout" style={{ marginTop: "-50px" }}>
          <Grid container spacing={5}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div
                style={{
                  fontSize: "28px",
                  fontFamily: "Montserrat",
                  textAlign: "justify",
                  color:
                    state.auth.theme == "dark"
                      ? themeStyleDark.primaryColor
                      : themeStyle.primaryColor,
                  fontWeight: "bold",
                }}
              >
                A Hub for Teamwork and Excellence
              </div>
              <br />
              <div
                style={{
                  fontSize: state.auth.isMobile ? "18px" : "22px",
                  fontFamily: "Montserrat",
                  textAlign: "justify",
                }}
              >
                Our Indoor Activity Room is a colorful haven for creativity and
                indoor play. When the weather keeps us inside, the fun doesn't
                stop. This room is filled with soft play cushions, large
                building blocks, and interactive learning walls. It's a space
                designed to let imaginations run wild in a safe, padded
                environment.
              </div>
            </Grid>
          </Grid>
        </div>
        <div className="aboutabout">
          <Grid container spacing={5}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div
                style={{
                  fontSize: "28px",
                  fontFamily: "Montserrat",
                  textAlign: "justify",
                  color:
                    state.auth.theme == "dark"
                      ? themeStyleDark.primaryColor
                      : themeStyle.primaryColor,
                  fontWeight: "bold",
                }}
              >
                Activity Room at ASPIRE Grove International Pre-School,
                Devanahalli Premium International Pre-School
              </div>
              <br />
              <div
                style={{
                  fontSize: state.auth.isMobile ? "18px" : "22px",
                  fontFamily: "Montserrat",
                  textAlign: "justify",
                }}
              >
                The Activity Room is equipped with a variety of educational toys
                and sensory materials. From role-play corners to puzzle
                stations, every corner offers a new learning opportunity. It
                serves as a multipurpose space for dance, music, and movement
                classes, ensuring that our little ones stay active and engaged
                regardless of the weather.
              </div>
            </Grid>
          </Grid>
        </div>
        <div
          className="aboutabout"
          style={{
            fontSize: state.auth.isMobile ? "18px" : "22px",
            marginBottom: "80px",
            marginTop: "100px",
          }}
        >
          <div
            style={{
              fontSize: "45px",
              fontWeight: "bold",
              fontFamily: "Montserrat",
              color: themeStyle.primaryColor,
            }}
          >
            Splash Pool
          </div>
        </div>
        <div className="aboutabout" style={{ marginTop: "-50px" }}>
          <Grid container spacing={5}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div
                style={{
                  fontSize: "28px",
                  fontFamily: "Montserrat",
                  textAlign: "justify",
                  color:
                    state.auth.theme == "dark"
                      ? themeStyleDark.primaryColor
                      : themeStyle.primaryColor,
                  fontWeight: "bold",
                }}
              >
                Splash Pool at ASPIRE Grove International Pre-School,
                Devanahalli Premium International Pre-School
              </div>
              <br />
              <div
                style={{
                  fontSize: state.auth.isMobile ? "18px" : "22px",
                  fontFamily: "Montserrat",
                  textAlign: "justify",
                }}
              >
                Our delightful Splash Pool is designed for water confidence and
                fun. Shallow and safe, it allows young children to experience
                the joy of water play under strict supervision. The water is
                temperature-controlled and hygienically maintained, providing a
                perfect setting for sensory experiences and cooling off on warm
                days.
              </div>
            </Grid>
          </Grid>
        </div>
        <div className="aboutabout">
          <Grid container spacing={5}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div
                style={{
                  fontSize: "28px",
                  fontFamily: "Montserrat",
                  textAlign: "left",
                  color:
                    state.auth.theme == "dark"
                      ? themeStyleDark.primaryColor
                      : themeStyle.primaryColor,
                  fontWeight: "bold",
                }}
              >
                A Splash of Fun and Learning
              </div>
              <br />
              <div
                style={{
                  fontSize: state.auth.isMobile ? "18px" : "22px",
                  fontFamily: "Montserrat",
                  textAlign: "justify",
                }}
              >
                The Splash Pool is where fear of water turns into fun. Through
                splash and play, children develop coordination and balance. It
                is not about swimming laps but about enjoying the water safely.
                Our teachers ensure that every child feels comfortable and
                secure, turning water play into a cherished activity.
              </div>
            </Grid>
          </Grid>
        </div>
        {/* <Benchmark /> */}
        <VisitUs />
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
